

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IShortUser} from "@/model/shortInterfaces";
  import {Prop, Watch} from "vue-property-decorator";
  import {IOnOffHandlers} from "bonomo/dist";
  import {IOrder} from "@/model/Order/orderInterfaces";

  const orderModule = namespace("orderModule");

  @Component({
    components: {}
  })
  export default class OrderSearch extends Vue {

    @Prop({default: true}) // inverse prop!!
    protected forToolbar!: boolean;

    @orderModule.Getter('search')
    protected items!: IOrder[];
    @orderModule.Action('searchOrders')
    protected searchOrders!: (search: string) => any;
    @orderModule.Action('clearSearch')
    protected clearSearch!: () => any;

    protected model: any = null;
    protected loading: boolean = false;
    protected search: any = null;
    protected subscribes: IOnOffHandlers = {};
    private timeout: any;

    @Watch('search')
    protected onSearch(val: string) {

      if (!this.validSearch(val)) {
        this.clear();
        return;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.loading = true;
        this.searchOrders(val);
      }, 500);

    }

    created() {
      this.subscribes = this.$ons({
        'backend.call.OK.orderSearchLoaded': this.onOK,
        'backend.call.KO.orderSearchLoaded': this.onOK,
      });
    }

    protected validSearch(search: string|null) {
      return !(search == null || search.length < 3);
    }

    protected onFocus() {
      this.clear();
    }

    protected onBlur() {
      if (!this.forToolbar) {
        this.clear();
      }
    }

    protected onChange(val: IShortUser) {
      this.$emit('change', val);
    }

    private onOK() {
      this.loading = false;
    }

    private clear() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.clearSearch();
    }

  }

